var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import phoneNumberFormatter from 'utils/phoneNumberFormatter';
export var PhoneNumber = function (_a) {
    var phoneNumber = _a.phoneNumber;
    var formatted = phoneNumberFormatter(phoneNumber);
    return React.createElement(Wrapper, null, formatted);
};
var Wrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: nowrap;\n  font: inherit;\n"], ["\n  white-space: nowrap;\n  font: inherit;\n"])));
var templateObject_1;
